// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e2e_recruiting_page{

  background:#ffffff;

  padding:22px;

  border-radius:20px;

  border:1px solid #e5e7eb;

  box-shadow:
    0 4px 20px rgba(15,23,42,0.05);
}

.showEntity{
  padding: 10px;
  border: #0f5fe0 1px solid;
  border-radius: 5px;
}

/* =========================
   TOP
========================= */

.e2e_recruiting_top{

  display:flex;

  justify-content:space-between;

  align-items:center;

  margin-bottom:20px;

  flex-wrap:wrap;

  gap:20px;
}

.e2e_recruiting_left h2{

  font-size:25px;

  font-weight:800;

  color:#111827;

  margin:0;
}

/* UNDERLINE */

.e2e_recruiting_heading_line{

  width:90px;

  height:5px;

  border-radius:20px;

  margin-top:10px;

  background:
    linear-gradient(
      90deg,
      #3b82f6,
      #8b5cf6
    );
}

/* BUTTON */

.e2e_recruiting_right button{

  border:none;

  background:#1677ff;

  color:white;

  padding:11px 22px;

  border-radius:12px;

  font-size:14px;

  font-weight:700;

  cursor:pointer;

  transition:0.3s ease;
}

.e2e_recruiting_right button:hover{

  transform:translateY(-2px);

  background:#0f5fe0;
}

/* =========================
   FILTERS
========================= */

.e2e_recruiting_filters{

  display:flex;

  justify-content:space-between;

  align-items:center;

  gap:20px;

  margin-bottom:20px;

  flex-wrap:wrap;
}

/* LEFT */

.e2e_recruiting_filter_left{

  display:flex;

  align-items:center;

  gap:18px;

  flex-wrap:wrap;
}

/* GROUP */

.e2e_filter_group{

  display:flex;

  align-items:center;

  gap:10px;
}

.e2e_filter_group label{

  font-size:14px;

  font-weight:700;

  color:#374151;
}

.e2e_filter_group span{

  font-size:14px;

  font-weight:600;

  color:#475569;
}

/* SELECT */

.e2e_filter_group select{

  min-width:190px;

  padding:10px 14px;

  border:1px solid #dbe2ea;

  border-radius:12px;

  outline:none;

  background:#f8fafc;

  font-size:14px;

  font-weight:600;

  color:#1e293b;

  cursor:pointer;

  transition:0.3s ease;
}

.e2e_filter_group select:focus{

  border-color:#2563eb;

  background:white;

  box-shadow:
    0 0 0 4px rgba(37,99,235,0.08);
}

/* SEARCH */

.e2e_recruiting_filter_right input{

  width:280px;

  padding:11px 16px;

  border:1px solid #dbe2ea;

  border-radius:12px;

  outline:none;

  font-size:14px;

  background:#f8fafc;

  transition:0.3s ease;
}

.e2e_recruiting_filter_right input:focus{

  border-color:#2563eb;

  background:white;

  box-shadow:
    0 0 0 4px rgba(37,99,235,0.08);
}

/* =========================
   TABLE
========================= */

.e2e_recruiting_table_wrapper{

  overflow-x:auto;
}

.e2e_recruiting_table_wrapper table{

  width:100%;

  border-collapse:collapse;
}

/* HEAD */

.e2e_recruiting_table_wrapper thead{

  background:#f8fafc;
}

.e2e_recruiting_table_wrapper th{

  padding:14px 16px;

  text-align:left;

  font-size:13px;

  font-weight:800;

  color:#475569;

  text-transform:uppercase;

  border-bottom:2px solid #dbe2ea;
}

/* BODY */

.e2e_recruiting_table_wrapper td{

  padding:14px 16px;

  font-size:14px;

  font-weight:600;

  color:#1e293b;

  border-bottom:1px solid #edf2f7;
}

.e2e_recruiting_table_wrapper tbody tr{

  transition:0.25s ease;
}

.e2e_recruiting_table_wrapper tbody tr:hover{

  background:#f8fbff;
}

/* NUMBER */

.e2e_recruiting_table_wrapper td:first-child{

  font-weight:800;

  color:#2563eb;
}

/* ACTIONS */

.e2e_recruiting_actions{

  display:flex;

  gap:8px;
}

/* BUTTONS */

.viewBtn,
.editBtn,
.deleteBtn{

  border:none;

  padding:7px 13px;

  border-radius:9px;

  font-size:12px;

  font-weight:700;

  cursor:pointer;

  transition:0.25s ease;
}

/* VIEW */

.viewBtn{

  background:#dbeafe;

  color:#2563eb;
}

.viewBtn:hover{

  background:#2563eb;

  color:white;
}

/* EDIT */

.editBtn{

  background:#fef3c7;

  color:#d97706;
}

.editBtn:hover{

  background:#f59e0b;

  color:white;
}

/* DELETE */

.deleteBtn{

  background:#fee2e2;

  color:#dc2626;
}

.deleteBtn:hover{

  background:#dc2626;

  color:white;
}

/* SCROLLBAR */

.e2e_recruiting_table_wrapper::-webkit-scrollbar{

  height:7px;
}

.e2e_recruiting_table_wrapper::-webkit-scrollbar-thumb{

  background:#cbd5e1;

  border-radius:20px;
}

/* RESPONSIVE */

@media screen and (max-width:768px){

  .e2e_recruiting_page{
    padding:14px;
    border-radius:16px;
  }

  .e2e_recruiting_top{

    flex-direction:column;

    align-items:stretch;
    gap:14px;
  }

  .e2e_recruiting_left h2{
    font-size:20px;
    line-height:1.25;
  }

  .e2e_recruiting_right,
  .e2e_recruiting_right button{
    width:100%;
  }

  .e2e_recruiting_right button{
    min-height:44px;
  }

  .e2e_recruiting_filters{

    flex-direction:column;

    align-items:stretch;
    gap:10px;
  }

  .e2e_recruiting_filters .e2e_pagination_number{
    width:100%;
    min-height:42px;
  }

  .e2e_recruiting_filter_left{

    flex-direction:column;

    align-items:stretch;
  }

  .e2e_filter_group{

    width:100%;
  }

  .e2e_filter_group select{

    width:100%;
  }

  .e2e_recruiting_filter_right input{

    width:100%;
  }

  .e2e_recruiting_table_wrapper table{

    min-width:850px;
  }

  .e2e_recruiting_table_wrapper{
    margin:0 -14px;
    padding:0 14px 8px;
  }

  .e2e_recruiting_table_wrapper th,
  .e2e_recruiting_table_wrapper td{
    padding:12px 10px;
  }

  .e2e_recruiting_actions button{
    min-height:38px;
    padding:8px 12px;
  }

}

.e2e_recruiting_summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(140px, 1fr));
  gap: 14px;
  margin: 18px 0;
}
.e2e_recruiting_summary article {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px;
  border: 1px solid #e4e7ec;
  border-radius: 12px;
  background: #fff;
}
.e2e_recruiting_summary span { color: #667085; font-weight: 600; }
.e2e_recruiting_summary strong { color: #101828; font-size: 24px; }
.e2e_recruiting_status {
  display: inline-flex;
  padding: 5px 9px;
  border-radius: 999px;
  background: #eef2ff;
  color: #4338ca;
  font-size: 12px;
  font-weight: 700;
}
.e2e_recruiting_status.process-2 { background: #fff7ed; color: #c2410c; }
.e2e_recruiting_status.process-3 { background: #ecfdf3; color: #047857; }
@media (max-width: 700px) {
  .e2e_recruiting_summary { grid-template-columns: 1fr; }
}
/* Recruiting process badges match the Bench Sales table. */
.e2e_recruiting_td_process{width:170px;min-width:170px;box-sizing:border-box;text-align:center!important}
.e2e_recruiting_process_content{display:flex;width:100%;min-height:52px;align-items:center;justify-content:center;flex-direction:column;gap:5px}
.e2e_recruiting_process_badge{display:inline-flex;width:142px;min-height:32px;box-sizing:border-box;align-items:center;justify-content:center;gap:6px;padding:6px 10px;border:1px solid transparent;border-radius:999px;font-size:11px;font-weight:800;line-height:1.2;white-space:nowrap}
.e2e_recruiting_process_submitted{color:#1d4ed8;background:#eff6ff;border-color:#bfdbfe}
.e2e_recruiting_process_interview{color:#a16207;background:#fefce8;border-color:#fde68a}
.e2e_recruiting_process_placed{color:#15803d;background:#dcfce7;border-color:#86efac;box-shadow:0 2px 8px rgba(22,163,74,.14)}
.e2e_recruiting_process_unknown{color:#64748b;background:#f1f5f9;border-color:#e2e8f0}
.e2e_recruiting_process_note{display:block;height:12px;margin:0;color:transparent;font-size:9px;font-weight:750;line-height:12px;white-space:nowrap;visibility:hidden}
.e2e_recruiting_process_note.visible{color:#15803d;visibility:visible}
@media(max-width:768px){.e2e_recruiting_td_process{width:160px;min-width:160px}.e2e_recruiting_process_badge{width:134px}}
.e2e_recruiting_right{display:flex;align-items:center;gap:10px;flex-wrap:wrap}
/* Scoped layout: Bench Sales also uses the original recruiting classes. */
.recruiting-workspace{width:100%;max-width:100%;min-width:0;box-sizing:border-box;padding:18px;border-radius:16px;border-color:#e4ebf5;animation:recruiting-enter .25s ease-out}
.recruiting-workspace .e2e_recruiting_top{gap:14px;margin-bottom:16px}
.recruiting-title{display:flex;align-items:center;gap:11px;min-width:0}
.recruiting-title-icon{display:grid;place-items:center;flex:0 0 42px;height:42px;border-radius:12px;background:linear-gradient(135deg,#e0efff,#ede9fe);color:#2563eb;font-size:20px}
.recruiting-title h2{margin:0;color:#14213d;font-size:22px;line-height:1.25;font-weight:800}
.recruiting-title p{margin:4px 0 0;color:#64748b;font-size:12px;line-height:1.5}
.recruiting-workspace .e2e_recruiting_right{gap:7px;min-width:0}
.recruiting-workspace .e2e_recruiting_right button{display:inline-flex;align-items:center;justify-content:center;gap:7px;min-height:36px;padding:8px 11px;border:1px solid #dbe6f5;border-radius:9px;font-size:11px;line-height:1.3;transition:background .18s,box-shadow .18s;transform:none}
.recruiting-workspace .e2e_recruiting_right .recruiting-tool-button{background:#f5f8ff;color:#31538b}
.recruiting-workspace .e2e_recruiting_right .recruiting-tool-button:hover{background:#e8efff;border-color:#b8cef8}
.recruiting-workspace .e2e_recruiting_right .recruiting-primary-button{background:linear-gradient(135deg,#1677ff,#2563eb);color:white;border-color:#2563eb;box-shadow:0 3px 8px #2563eb22}
.recruiting-workspace .e2e_recruiting_right .recruiting-primary-button:hover{background:#1d4ed8}
.recruiting-workspace .application-list-controls{background:#f8faff;box-shadow:none;flex-wrap:wrap;gap:10px;margin:0 0 12px}
.recruiting-workspace .application-period-control{flex:0 1 150px}
.recruiting-workspace .application-search-control{flex:1 1 190px}
.recruiting-workspace .application-custom-dates{flex:1 1 270px;min-width:0}
.recruiting-workspace .application-list-controls input,.recruiting-workspace .application-list-controls select{box-sizing:border-box;font-size:12px}
.recruiting-workspace .e2e_recruiting_table_wrapper{max-width:100%;margin:0;padding:0;overflow:auto;border-radius:12px;scrollbar-width:thin}
.recruiting-workspace table{width:100%;min-width:880px;table-layout:fixed;border-collapse:separate;border-spacing:0 7px}
.recruiting-col-number{width:36px}.recruiting-col-date{width:100px}.recruiting-col-status{width:128px}.recruiting-col-actions{width:144px}
.recruiting-workspace .e2e_recruiting_table_wrapper th{padding:11px 8px;background:#f1f5fc;color:#536783;border-top:1px solid #e1e8f4;border-bottom:1px solid #e1e8f4;font-size:10px;letter-spacing:.035em;line-height:1.5;overflow-wrap:anywhere}
.recruiting-workspace .e2e_recruiting_table_wrapper td{padding:12px 8px;border-top:1px solid #edf1f7;border-bottom:1px solid #edf1f7;font-size:12px;line-height:1.5;font-weight:500;vertical-align:middle;overflow-wrap:anywhere;background:#fff}
.recruiting-workspace .e2e_recruiting_table_wrapper th:first-child,.recruiting-workspace .e2e_recruiting_table_wrapper td:first-child{border-left:1px solid #edf1f7;border-radius:10px 0 0 10px;text-align:center}
.recruiting-workspace .e2e_recruiting_table_wrapper th:last-child,.recruiting-workspace .e2e_recruiting_table_wrapper td:last-child{border-right:1px solid #edf1f7;border-radius:0 10px 10px 0}
.recruiting-workspace .e2e_recruiting_table_wrapper tbody tr:hover td{background:#f8fbff}
.recruiting-workspace .e2e_recruiting_table_wrapper .recruiting-row-placed td{border-top-color:#ccebd8;border-bottom-color:#ccebd8;background:#f7fdf9}
.recruiting-workspace .e2e_recruiting_table_wrapper .recruiting-row-placed td:first-child{border-left:3px solid #22c55e}
.recruiting-candidate-role{display:block;margin-top:3px;color:#64748b;font-size:10px;font-weight:500}
.recruiting-workspace .e2e_recruiting_td_process{width:auto;min-width:0}
.recruiting-workspace .e2e_recruiting_process_content{min-height:32px;gap:3px}
.recruiting-workspace .e2e_recruiting_process_badge{width:auto;max-width:100%;min-height:28px;padding:5px 8px;font-size:10px;white-space:normal}
.recruiting-workspace .e2e_recruiting_process_note{display:none}
.recruiting-workspace .e2e_recruiting_process_note.visible{display:block;font-size:9px}
.recruiting-workspace .e2e_recruiting_actions{gap:4px;flex-wrap:wrap}
.recruiting-workspace .e2e_recruiting_actions button{padding:6px 8px;min-height:30px;font-size:10px;border-radius:7px}
.recruiting-workspace .application-list-footer{align-items:center;flex-wrap:wrap;gap:10px;margin-top:10px}
.recruiting-page-caption{color:#64748b;font-size:11px}
.recruiting-workspace .application-list-footer .e2e_pagination_container{flex-wrap:wrap;gap:5px}
.recruiting-workspace button:focus-visible,.recruiting-workspace .e2e_recruiting_table_wrapper:focus-visible{outline:2px solid #2563eb;outline-offset:3px}
@keyframes recruiting-enter{from{opacity:0;transform:translateY(5px)}to{opacity:1;transform:translateY(0)}}
@media(max-width:1100px){.recruiting-workspace .e2e_recruiting_right{width:100%}.recruiting-workspace .e2e_recruiting_right .recruiting-primary-button{margin-left:auto}}
@media(max-width:680px){.recruiting-workspace{padding:12px}.recruiting-workspace .e2e_recruiting_top{align-items:stretch;gap:12px}.recruiting-title h2{font-size:20px}.recruiting-workspace .e2e_recruiting_right{display:grid;grid-template-columns:repeat(2,minmax(0,1fr))}.recruiting-workspace .e2e_recruiting_right button{width:100%;min-height:40px}.recruiting-workspace .e2e_recruiting_right .recruiting-primary-button{margin-left:0}.recruiting-workspace .application-list-controls{padding:10px}.recruiting-workspace .application-period-control,.recruiting-workspace .application-search-control,.recruiting-workspace .application-custom-dates{flex:auto;width:100%}.recruiting-workspace .application-list-footer{flex-direction:row}.recruiting-workspace .application-list-footer .e2e_pagination_container{width:100%;justify-content:center}.recruiting-workspace .recruiting-page-caption{margin-left:auto}}
@media(prefers-reduced-motion:reduce){.recruiting-workspace{animation:none}.recruiting-workspace *{transition:none!important}}
`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard/recruiting.css"],"names":[],"mappings":"AAAA;;EAEE,kBAAkB;;EAElB,YAAY;;EAEZ,kBAAkB;;EAElB,wBAAwB;;EAExB;kCACgC;AAClC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;2BAE2B;;AAE3B;;EAEE,YAAY;;EAEZ,6BAA6B;;EAE7B,kBAAkB;;EAElB,kBAAkB;;EAElB,cAAc;;EAEd,QAAQ;AACV;;AAEA;;EAEE,cAAc;;EAEd,eAAe;;EAEf,aAAa;;EAEb,QAAQ;AACV;;AAEA,cAAc;;AAEd;;EAEE,UAAU;;EAEV,UAAU;;EAEV,kBAAkB;;EAElB,eAAe;;EAEf;;;;;KAKG;AACL;;AAEA,WAAW;;AAEX;;EAEE,WAAW;;EAEX,kBAAkB;;EAElB,WAAW;;EAEX,iBAAiB;;EAEjB,kBAAkB;;EAElB,cAAc;;EAEd,eAAe;;EAEf,cAAc;;EAEd,oBAAoB;AACtB;;AAEA;;EAEE,0BAA0B;;EAE1B,kBAAkB;AACpB;;AAEA;;2BAE2B;;AAE3B;;EAEE,YAAY;;EAEZ,6BAA6B;;EAE7B,kBAAkB;;EAElB,QAAQ;;EAER,kBAAkB;;EAElB,cAAc;AAChB;;AAEA,SAAS;;AAET;;EAEE,YAAY;;EAEZ,kBAAkB;;EAElB,QAAQ;;EAER,cAAc;AAChB;;AAEA,UAAU;;AAEV;;EAEE,YAAY;;EAEZ,kBAAkB;;EAElB,QAAQ;AACV;;AAEA;;EAEE,cAAc;;EAEd,eAAe;;EAEf,aAAa;AACf;;AAEA;;EAEE,cAAc;;EAEd,eAAe;;EAEf,aAAa;AACf;;AAEA,WAAW;;AAEX;;EAEE,eAAe;;EAEf,iBAAiB;;EAEjB,wBAAwB;;EAExB,kBAAkB;;EAElB,YAAY;;EAEZ,kBAAkB;;EAElB,cAAc;;EAEd,eAAe;;EAEf,aAAa;;EAEb,cAAc;;EAEd,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;;EAEpB,gBAAgB;;EAEhB;kCACgC;AAClC;;AAEA,WAAW;;AAEX;;EAEE,WAAW;;EAEX,iBAAiB;;EAEjB,wBAAwB;;EAExB,kBAAkB;;EAElB,YAAY;;EAEZ,cAAc;;EAEd,kBAAkB;;EAElB,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;;EAEpB,gBAAgB;;EAEhB;kCACgC;AAClC;;AAEA;;2BAE2B;;AAE3B;;EAEE,eAAe;AACjB;;AAEA;;EAEE,UAAU;;EAEV,wBAAwB;AAC1B;;AAEA,SAAS;;AAET;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;;EAEjB,eAAe;;EAEf,cAAc;;EAEd,eAAe;;EAEf,aAAa;;EAEb,wBAAwB;;EAExB,+BAA+B;AACjC;;AAEA,SAAS;;AAET;;EAEE,iBAAiB;;EAEjB,cAAc;;EAEd,eAAe;;EAEf,aAAa;;EAEb,+BAA+B;AACjC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,WAAW;;AAEX;;EAEE,eAAe;;EAEf,aAAa;AACf;;AAEA,YAAY;;AAEZ;;EAEE,YAAY;;EAEZ,OAAO;AACT;;AAEA,YAAY;;AAEZ;;;;EAIE,WAAW;;EAEX,gBAAgB;;EAEhB,iBAAiB;;EAEjB,cAAc;;EAEd,eAAe;;EAEf,cAAc;;EAEd,qBAAqB;AACvB;;AAEA,SAAS;;AAET;;EAEE,kBAAkB;;EAElB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;;EAElB,WAAW;AACb;;AAEA,SAAS;;AAET;;EAEE,kBAAkB;;EAElB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;;EAElB,WAAW;AACb;;AAEA,WAAW;;AAEX;;EAEE,kBAAkB;;EAElB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;;EAElB,WAAW;AACb;;AAEA,cAAc;;AAEd;;EAEE,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;;EAElB,kBAAkB;AACpB;;AAEA,eAAe;;AAEf;;EAEE;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;;IAEE,qBAAqB;;IAErB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,qBAAqB;;IAErB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;;IAEE,qBAAqB;;IAErB,mBAAmB;EACrB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;AAEF;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA,+BAA+B,cAAc,EAAE,gBAAgB,EAAE;AACjE,iCAAiC,cAAc,EAAE,eAAe,EAAE;AAClE;EACE,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA,mCAAmC,mBAAmB,EAAE,cAAc,EAAE;AACxE,mCAAmC,mBAAmB,EAAE,cAAc,EAAE;AACxE;EACE,0BAA0B,0BAA0B,EAAE;AACxD;AACA,2DAA2D;AAC3D,2BAA2B,WAAW,CAAC,eAAe,CAAC,qBAAqB,CAAC,2BAA2B;AACxG,gCAAgC,YAAY,CAAC,UAAU,CAAC,eAAe,CAAC,kBAAkB,CAAC,sBAAsB,CAAC,qBAAqB,CAAC,OAAO;AAC/I,8BAA8B,mBAAmB,CAAC,WAAW,CAAC,eAAe,CAAC,qBAAqB,CAAC,kBAAkB,CAAC,sBAAsB,CAAC,OAAO,CAAC,gBAAgB,CAAC,4BAA4B,CAAC,mBAAmB,CAAC,cAAc,CAAC,eAAe,CAAC,eAAe,CAAC,kBAAkB;AACzR,kCAAkC,aAAa,CAAC,kBAAkB,CAAC,oBAAoB;AACvF,kCAAkC,aAAa,CAAC,kBAAkB,CAAC,oBAAoB;AACvF,+BAA+B,aAAa,CAAC,kBAAkB,CAAC,oBAAoB,CAAC,wCAAwC;AAC7H,gCAAgC,aAAa,CAAC,kBAAkB,CAAC,oBAAoB;AACrF,6BAA6B,aAAa,CAAC,WAAW,CAAC,QAAQ,CAAC,iBAAiB,CAAC,aAAa,CAAC,eAAe,CAAC,gBAAgB,CAAC,kBAAkB,CAAC,iBAAiB;AACrK,qCAAqC,aAAa,CAAC,kBAAkB;AACrE,wBAAwB,2BAA2B,WAAW,CAAC,eAAe,CAAC,8BAA8B,WAAW,CAAC;AACzH,sBAAsB,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,cAAc;AAC7E,0EAA0E;AAC1E,sBAAsB,UAAU,CAAC,cAAc,CAAC,WAAW,CAAC,qBAAqB,CAAC,YAAY,CAAC,kBAAkB,CAAC,oBAAoB,CAAC,wCAAwC;AAC/K,0CAA0C,QAAQ,CAAC,kBAAkB;AACrE,kBAAkB,YAAY,CAAC,kBAAkB,CAAC,QAAQ,CAAC,WAAW;AACtE,uBAAuB,YAAY,CAAC,kBAAkB,CAAC,aAAa,CAAC,WAAW,CAAC,kBAAkB,CAAC,kDAAkD,CAAC,aAAa,CAAC,cAAc;AACnL,qBAAqB,QAAQ,CAAC,aAAa,CAAC,cAAc,CAAC,gBAAgB,CAAC,eAAe;AAC3F,oBAAoB,cAAc,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe;AAC/E,4CAA4C,OAAO,CAAC,WAAW;AAC/D,mDAAmD,mBAAmB,CAAC,kBAAkB,CAAC,sBAAsB,CAAC,OAAO,CAAC,eAAe,CAAC,gBAAgB,CAAC,wBAAwB,CAAC,iBAAiB,CAAC,cAAc,CAAC,eAAe,CAAC,0CAA0C,CAAC,cAAc;AAC7R,oEAAoE,kBAAkB,CAAC,aAAa;AACpG,0EAA0E,kBAAkB,CAAC,oBAAoB;AACjH,uEAAuE,kDAAkD,CAAC,WAAW,CAAC,oBAAoB,CAAC,8BAA8B;AACzL,6EAA6E,kBAAkB;AAC/F,iDAAiD,kBAAkB,CAAC,eAAe,CAAC,cAAc,CAAC,QAAQ,CAAC,eAAe;AAC3H,kDAAkD,cAAc;AAChE,kDAAkD,cAAc;AAChE,gDAAgD,cAAc,CAAC,WAAW;AAC1E,+GAA+G,qBAAqB,CAAC,cAAc;AACnJ,oDAAoD,cAAc,CAAC,QAAQ,CAAC,SAAS,CAAC,aAAa,CAAC,kBAAkB,CAAC,oBAAoB;AAC3I,4BAA4B,UAAU,CAAC,eAAe,CAAC,kBAAkB,CAAC,wBAAwB,CAAC,oBAAoB;AACvH,uBAAuB,UAAU,CAAC,qBAAqB,WAAW,CAAC,uBAAuB,WAAW,CAAC,wBAAwB,WAAW;AACzI,uDAAuD,gBAAgB,CAAC,kBAAkB,CAAC,aAAa,CAAC,4BAA4B,CAAC,+BAA+B,CAAC,cAAc,CAAC,qBAAqB,CAAC,eAAe,CAAC,sBAAsB;AACjP,uDAAuD,gBAAgB,CAAC,4BAA4B,CAAC,+BAA+B,CAAC,cAAc,CAAC,eAAe,CAAC,eAAe,CAAC,qBAAqB,CAAC,sBAAsB,CAAC,eAAe;AAChP,sIAAsI,6BAA6B,CAAC,2BAA2B,CAAC,iBAAiB;AACjN,oIAAoI,8BAA8B,CAAC,2BAA2B;AAC9L,sEAAsE,kBAAkB;AACxF,8EAA8E,wBAAwB,CAAC,2BAA2B,CAAC,kBAAkB;AACrJ,0FAA0F,6BAA6B;AACvH,2BAA2B,aAAa,CAAC,cAAc,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe;AACpG,iDAAiD,UAAU,CAAC,WAAW;AACvE,sDAAsD,eAAe,CAAC,OAAO;AAC7E,oDAAoD,UAAU,CAAC,cAAc,CAAC,eAAe,CAAC,eAAe,CAAC,cAAc,CAAC,kBAAkB;AAC/I,mDAAmD,YAAY;AAC/D,2DAA2D,aAAa,CAAC,aAAa;AACtF,8CAA8C,OAAO,CAAC,cAAc;AACpE,qDAAqD,eAAe,CAAC,eAAe,CAAC,cAAc,CAAC,iBAAiB;AACrH,+CAA+C,kBAAkB,CAAC,cAAc,CAAC,QAAQ,CAAC,eAAe;AACzG,yBAAyB,aAAa,CAAC,cAAc;AACrD,yEAAyE,cAAc,CAAC,OAAO;AAC/F,6GAA6G,yBAAyB,CAAC,kBAAkB;AACzJ,4BAA4B,KAAK,SAAS,CAAC,yBAAyB,CAAC,GAAG,SAAS,CAAC,uBAAuB,CAAC;AAC1G,yBAAyB,4CAA4C,UAAU,CAAC,uEAAuE,gBAAgB,CAAC;AACxK,wBAAwB,sBAAsB,YAAY,CAAC,0CAA0C,mBAAmB,CAAC,QAAQ,CAAC,qBAAqB,cAAc,CAAC,4CAA4C,YAAY,CAAC,6CAA6C,CAAC,mDAAmD,UAAU,CAAC,eAAe,CAAC,uEAAuE,aAAa,CAAC,iDAAiD,YAAY,CAAC,oJAAoJ,SAAS,CAAC,UAAU,CAAC,+CAA+C,kBAAkB,CAAC,yEAAyE,UAAU,CAAC,sBAAsB,CAAC,+CAA+C,gBAAgB,CAAC;AACp4B,sCAAsC,sBAAsB,cAAc,CAAC,wBAAwB,yBAAyB,CAAC","sourcesContent":[".e2e_recruiting_page{\r\n\r\n  background:#ffffff;\r\n\r\n  padding:22px;\r\n\r\n  border-radius:20px;\r\n\r\n  border:1px solid #e5e7eb;\r\n\r\n  box-shadow:\r\n    0 4px 20px rgba(15,23,42,0.05);\r\n}\r\n\r\n.showEntity{\r\n  padding: 10px;\r\n  border: #0f5fe0 1px solid;\r\n  border-radius: 5px;\r\n}\r\n\r\n/* =========================\r\n   TOP\r\n========================= */\r\n\r\n.e2e_recruiting_top{\r\n\r\n  display:flex;\r\n\r\n  justify-content:space-between;\r\n\r\n  align-items:center;\r\n\r\n  margin-bottom:20px;\r\n\r\n  flex-wrap:wrap;\r\n\r\n  gap:20px;\r\n}\r\n\r\n.e2e_recruiting_left h2{\r\n\r\n  font-size:25px;\r\n\r\n  font-weight:800;\r\n\r\n  color:#111827;\r\n\r\n  margin:0;\r\n}\r\n\r\n/* UNDERLINE */\r\n\r\n.e2e_recruiting_heading_line{\r\n\r\n  width:90px;\r\n\r\n  height:5px;\r\n\r\n  border-radius:20px;\r\n\r\n  margin-top:10px;\r\n\r\n  background:\r\n    linear-gradient(\r\n      90deg,\r\n      #3b82f6,\r\n      #8b5cf6\r\n    );\r\n}\r\n\r\n/* BUTTON */\r\n\r\n.e2e_recruiting_right button{\r\n\r\n  border:none;\r\n\r\n  background:#1677ff;\r\n\r\n  color:white;\r\n\r\n  padding:11px 22px;\r\n\r\n  border-radius:12px;\r\n\r\n  font-size:14px;\r\n\r\n  font-weight:700;\r\n\r\n  cursor:pointer;\r\n\r\n  transition:0.3s ease;\r\n}\r\n\r\n.e2e_recruiting_right button:hover{\r\n\r\n  transform:translateY(-2px);\r\n\r\n  background:#0f5fe0;\r\n}\r\n\r\n/* =========================\r\n   FILTERS\r\n========================= */\r\n\r\n.e2e_recruiting_filters{\r\n\r\n  display:flex;\r\n\r\n  justify-content:space-between;\r\n\r\n  align-items:center;\r\n\r\n  gap:20px;\r\n\r\n  margin-bottom:20px;\r\n\r\n  flex-wrap:wrap;\r\n}\r\n\r\n/* LEFT */\r\n\r\n.e2e_recruiting_filter_left{\r\n\r\n  display:flex;\r\n\r\n  align-items:center;\r\n\r\n  gap:18px;\r\n\r\n  flex-wrap:wrap;\r\n}\r\n\r\n/* GROUP */\r\n\r\n.e2e_filter_group{\r\n\r\n  display:flex;\r\n\r\n  align-items:center;\r\n\r\n  gap:10px;\r\n}\r\n\r\n.e2e_filter_group label{\r\n\r\n  font-size:14px;\r\n\r\n  font-weight:700;\r\n\r\n  color:#374151;\r\n}\r\n\r\n.e2e_filter_group span{\r\n\r\n  font-size:14px;\r\n\r\n  font-weight:600;\r\n\r\n  color:#475569;\r\n}\r\n\r\n/* SELECT */\r\n\r\n.e2e_filter_group select{\r\n\r\n  min-width:190px;\r\n\r\n  padding:10px 14px;\r\n\r\n  border:1px solid #dbe2ea;\r\n\r\n  border-radius:12px;\r\n\r\n  outline:none;\r\n\r\n  background:#f8fafc;\r\n\r\n  font-size:14px;\r\n\r\n  font-weight:600;\r\n\r\n  color:#1e293b;\r\n\r\n  cursor:pointer;\r\n\r\n  transition:0.3s ease;\r\n}\r\n\r\n.e2e_filter_group select:focus{\r\n\r\n  border-color:#2563eb;\r\n\r\n  background:white;\r\n\r\n  box-shadow:\r\n    0 0 0 4px rgba(37,99,235,0.08);\r\n}\r\n\r\n/* SEARCH */\r\n\r\n.e2e_recruiting_filter_right input{\r\n\r\n  width:280px;\r\n\r\n  padding:11px 16px;\r\n\r\n  border:1px solid #dbe2ea;\r\n\r\n  border-radius:12px;\r\n\r\n  outline:none;\r\n\r\n  font-size:14px;\r\n\r\n  background:#f8fafc;\r\n\r\n  transition:0.3s ease;\r\n}\r\n\r\n.e2e_recruiting_filter_right input:focus{\r\n\r\n  border-color:#2563eb;\r\n\r\n  background:white;\r\n\r\n  box-shadow:\r\n    0 0 0 4px rgba(37,99,235,0.08);\r\n}\r\n\r\n/* =========================\r\n   TABLE\r\n========================= */\r\n\r\n.e2e_recruiting_table_wrapper{\r\n\r\n  overflow-x:auto;\r\n}\r\n\r\n.e2e_recruiting_table_wrapper table{\r\n\r\n  width:100%;\r\n\r\n  border-collapse:collapse;\r\n}\r\n\r\n/* HEAD */\r\n\r\n.e2e_recruiting_table_wrapper thead{\r\n\r\n  background:#f8fafc;\r\n}\r\n\r\n.e2e_recruiting_table_wrapper th{\r\n\r\n  padding:14px 16px;\r\n\r\n  text-align:left;\r\n\r\n  font-size:13px;\r\n\r\n  font-weight:800;\r\n\r\n  color:#475569;\r\n\r\n  text-transform:uppercase;\r\n\r\n  border-bottom:2px solid #dbe2ea;\r\n}\r\n\r\n/* BODY */\r\n\r\n.e2e_recruiting_table_wrapper td{\r\n\r\n  padding:14px 16px;\r\n\r\n  font-size:14px;\r\n\r\n  font-weight:600;\r\n\r\n  color:#1e293b;\r\n\r\n  border-bottom:1px solid #edf2f7;\r\n}\r\n\r\n.e2e_recruiting_table_wrapper tbody tr{\r\n\r\n  transition:0.25s ease;\r\n}\r\n\r\n.e2e_recruiting_table_wrapper tbody tr:hover{\r\n\r\n  background:#f8fbff;\r\n}\r\n\r\n/* NUMBER */\r\n\r\n.e2e_recruiting_table_wrapper td:first-child{\r\n\r\n  font-weight:800;\r\n\r\n  color:#2563eb;\r\n}\r\n\r\n/* ACTIONS */\r\n\r\n.e2e_recruiting_actions{\r\n\r\n  display:flex;\r\n\r\n  gap:8px;\r\n}\r\n\r\n/* BUTTONS */\r\n\r\n.viewBtn,\r\n.editBtn,\r\n.deleteBtn{\r\n\r\n  border:none;\r\n\r\n  padding:7px 13px;\r\n\r\n  border-radius:9px;\r\n\r\n  font-size:12px;\r\n\r\n  font-weight:700;\r\n\r\n  cursor:pointer;\r\n\r\n  transition:0.25s ease;\r\n}\r\n\r\n/* VIEW */\r\n\r\n.viewBtn{\r\n\r\n  background:#dbeafe;\r\n\r\n  color:#2563eb;\r\n}\r\n\r\n.viewBtn:hover{\r\n\r\n  background:#2563eb;\r\n\r\n  color:white;\r\n}\r\n\r\n/* EDIT */\r\n\r\n.editBtn{\r\n\r\n  background:#fef3c7;\r\n\r\n  color:#d97706;\r\n}\r\n\r\n.editBtn:hover{\r\n\r\n  background:#f59e0b;\r\n\r\n  color:white;\r\n}\r\n\r\n/* DELETE */\r\n\r\n.deleteBtn{\r\n\r\n  background:#fee2e2;\r\n\r\n  color:#dc2626;\r\n}\r\n\r\n.deleteBtn:hover{\r\n\r\n  background:#dc2626;\r\n\r\n  color:white;\r\n}\r\n\r\n/* SCROLLBAR */\r\n\r\n.e2e_recruiting_table_wrapper::-webkit-scrollbar{\r\n\r\n  height:7px;\r\n}\r\n\r\n.e2e_recruiting_table_wrapper::-webkit-scrollbar-thumb{\r\n\r\n  background:#cbd5e1;\r\n\r\n  border-radius:20px;\r\n}\r\n\r\n/* RESPONSIVE */\r\n\r\n@media screen and (max-width:768px){\r\n\r\n  .e2e_recruiting_page{\r\n    padding:14px;\r\n    border-radius:16px;\r\n  }\r\n\r\n  .e2e_recruiting_top{\r\n\r\n    flex-direction:column;\r\n\r\n    align-items:stretch;\r\n    gap:14px;\r\n  }\r\n\r\n  .e2e_recruiting_left h2{\r\n    font-size:20px;\r\n    line-height:1.25;\r\n  }\r\n\r\n  .e2e_recruiting_right,\r\n  .e2e_recruiting_right button{\r\n    width:100%;\r\n  }\r\n\r\n  .e2e_recruiting_right button{\r\n    min-height:44px;\r\n  }\r\n\r\n  .e2e_recruiting_filters{\r\n\r\n    flex-direction:column;\r\n\r\n    align-items:stretch;\r\n    gap:10px;\r\n  }\r\n\r\n  .e2e_recruiting_filters .e2e_pagination_number{\r\n    width:100%;\r\n    min-height:42px;\r\n  }\r\n\r\n  .e2e_recruiting_filter_left{\r\n\r\n    flex-direction:column;\r\n\r\n    align-items:stretch;\r\n  }\r\n\r\n  .e2e_filter_group{\r\n\r\n    width:100%;\r\n  }\r\n\r\n  .e2e_filter_group select{\r\n\r\n    width:100%;\r\n  }\r\n\r\n  .e2e_recruiting_filter_right input{\r\n\r\n    width:100%;\r\n  }\r\n\r\n  .e2e_recruiting_table_wrapper table{\r\n\r\n    min-width:850px;\r\n  }\r\n\r\n  .e2e_recruiting_table_wrapper{\r\n    margin:0 -14px;\r\n    padding:0 14px 8px;\r\n  }\r\n\r\n  .e2e_recruiting_table_wrapper th,\r\n  .e2e_recruiting_table_wrapper td{\r\n    padding:12px 10px;\r\n  }\r\n\r\n  .e2e_recruiting_actions button{\r\n    min-height:38px;\r\n    padding:8px 12px;\r\n  }\r\n\r\n}\r\n\r\n.e2e_recruiting_summary {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, minmax(140px, 1fr));\r\n  gap: 14px;\r\n  margin: 18px 0;\r\n}\r\n.e2e_recruiting_summary article {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 18px 20px;\r\n  border: 1px solid #e4e7ec;\r\n  border-radius: 12px;\r\n  background: #fff;\r\n}\r\n.e2e_recruiting_summary span { color: #667085; font-weight: 600; }\r\n.e2e_recruiting_summary strong { color: #101828; font-size: 24px; }\r\n.e2e_recruiting_status {\r\n  display: inline-flex;\r\n  padding: 5px 9px;\r\n  border-radius: 999px;\r\n  background: #eef2ff;\r\n  color: #4338ca;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n}\r\n.e2e_recruiting_status.process-2 { background: #fff7ed; color: #c2410c; }\r\n.e2e_recruiting_status.process-3 { background: #ecfdf3; color: #047857; }\r\n@media (max-width: 700px) {\r\n  .e2e_recruiting_summary { grid-template-columns: 1fr; }\r\n}\r\n/* Recruiting process badges match the Bench Sales table. */\r\n.e2e_recruiting_td_process{width:170px;min-width:170px;box-sizing:border-box;text-align:center!important}\r\n.e2e_recruiting_process_content{display:flex;width:100%;min-height:52px;align-items:center;justify-content:center;flex-direction:column;gap:5px}\r\n.e2e_recruiting_process_badge{display:inline-flex;width:142px;min-height:32px;box-sizing:border-box;align-items:center;justify-content:center;gap:6px;padding:6px 10px;border:1px solid transparent;border-radius:999px;font-size:11px;font-weight:800;line-height:1.2;white-space:nowrap}\r\n.e2e_recruiting_process_submitted{color:#1d4ed8;background:#eff6ff;border-color:#bfdbfe}\r\n.e2e_recruiting_process_interview{color:#a16207;background:#fefce8;border-color:#fde68a}\r\n.e2e_recruiting_process_placed{color:#15803d;background:#dcfce7;border-color:#86efac;box-shadow:0 2px 8px rgba(22,163,74,.14)}\r\n.e2e_recruiting_process_unknown{color:#64748b;background:#f1f5f9;border-color:#e2e8f0}\r\n.e2e_recruiting_process_note{display:block;height:12px;margin:0;color:transparent;font-size:9px;font-weight:750;line-height:12px;white-space:nowrap;visibility:hidden}\r\n.e2e_recruiting_process_note.visible{color:#15803d;visibility:visible}\r\n@media(max-width:768px){.e2e_recruiting_td_process{width:160px;min-width:160px}.e2e_recruiting_process_badge{width:134px}}\r\n.e2e_recruiting_right{display:flex;align-items:center;gap:10px;flex-wrap:wrap}\r\n/* Scoped layout: Bench Sales also uses the original recruiting classes. */\n.recruiting-workspace{width:100%;max-width:100%;min-width:0;box-sizing:border-box;padding:18px;border-radius:16px;border-color:#e4ebf5;animation:recruiting-enter .25s ease-out}\n.recruiting-workspace .e2e_recruiting_top{gap:14px;margin-bottom:16px}\n.recruiting-title{display:flex;align-items:center;gap:11px;min-width:0}\n.recruiting-title-icon{display:grid;place-items:center;flex:0 0 42px;height:42px;border-radius:12px;background:linear-gradient(135deg,#e0efff,#ede9fe);color:#2563eb;font-size:20px}\n.recruiting-title h2{margin:0;color:#14213d;font-size:22px;line-height:1.25;font-weight:800}\n.recruiting-title p{margin:4px 0 0;color:#64748b;font-size:12px;line-height:1.5}\n.recruiting-workspace .e2e_recruiting_right{gap:7px;min-width:0}\n.recruiting-workspace .e2e_recruiting_right button{display:inline-flex;align-items:center;justify-content:center;gap:7px;min-height:36px;padding:8px 11px;border:1px solid #dbe6f5;border-radius:9px;font-size:11px;line-height:1.3;transition:background .18s,box-shadow .18s;transform:none}\n.recruiting-workspace .e2e_recruiting_right .recruiting-tool-button{background:#f5f8ff;color:#31538b}\n.recruiting-workspace .e2e_recruiting_right .recruiting-tool-button:hover{background:#e8efff;border-color:#b8cef8}\n.recruiting-workspace .e2e_recruiting_right .recruiting-primary-button{background:linear-gradient(135deg,#1677ff,#2563eb);color:white;border-color:#2563eb;box-shadow:0 3px 8px #2563eb22}\n.recruiting-workspace .e2e_recruiting_right .recruiting-primary-button:hover{background:#1d4ed8}\n.recruiting-workspace .application-list-controls{background:#f8faff;box-shadow:none;flex-wrap:wrap;gap:10px;margin:0 0 12px}\n.recruiting-workspace .application-period-control{flex:0 1 150px}\n.recruiting-workspace .application-search-control{flex:1 1 190px}\n.recruiting-workspace .application-custom-dates{flex:1 1 270px;min-width:0}\n.recruiting-workspace .application-list-controls input,.recruiting-workspace .application-list-controls select{box-sizing:border-box;font-size:12px}\n.recruiting-workspace .e2e_recruiting_table_wrapper{max-width:100%;margin:0;padding:0;overflow:auto;border-radius:12px;scrollbar-width:thin}\n.recruiting-workspace table{width:100%;min-width:880px;table-layout:fixed;border-collapse:separate;border-spacing:0 7px}\n.recruiting-col-number{width:36px}.recruiting-col-date{width:100px}.recruiting-col-status{width:128px}.recruiting-col-actions{width:144px}\n.recruiting-workspace .e2e_recruiting_table_wrapper th{padding:11px 8px;background:#f1f5fc;color:#536783;border-top:1px solid #e1e8f4;border-bottom:1px solid #e1e8f4;font-size:10px;letter-spacing:.035em;line-height:1.5;overflow-wrap:anywhere}\n.recruiting-workspace .e2e_recruiting_table_wrapper td{padding:12px 8px;border-top:1px solid #edf1f7;border-bottom:1px solid #edf1f7;font-size:12px;line-height:1.5;font-weight:500;vertical-align:middle;overflow-wrap:anywhere;background:#fff}\n.recruiting-workspace .e2e_recruiting_table_wrapper th:first-child,.recruiting-workspace .e2e_recruiting_table_wrapper td:first-child{border-left:1px solid #edf1f7;border-radius:10px 0 0 10px;text-align:center}\n.recruiting-workspace .e2e_recruiting_table_wrapper th:last-child,.recruiting-workspace .e2e_recruiting_table_wrapper td:last-child{border-right:1px solid #edf1f7;border-radius:0 10px 10px 0}\n.recruiting-workspace .e2e_recruiting_table_wrapper tbody tr:hover td{background:#f8fbff}\n.recruiting-workspace .e2e_recruiting_table_wrapper .recruiting-row-placed td{border-top-color:#ccebd8;border-bottom-color:#ccebd8;background:#f7fdf9}\n.recruiting-workspace .e2e_recruiting_table_wrapper .recruiting-row-placed td:first-child{border-left:3px solid #22c55e}\n.recruiting-candidate-role{display:block;margin-top:3px;color:#64748b;font-size:10px;font-weight:500}\n.recruiting-workspace .e2e_recruiting_td_process{width:auto;min-width:0}\n.recruiting-workspace .e2e_recruiting_process_content{min-height:32px;gap:3px}\n.recruiting-workspace .e2e_recruiting_process_badge{width:auto;max-width:100%;min-height:28px;padding:5px 8px;font-size:10px;white-space:normal}\n.recruiting-workspace .e2e_recruiting_process_note{display:none}\n.recruiting-workspace .e2e_recruiting_process_note.visible{display:block;font-size:9px}\n.recruiting-workspace .e2e_recruiting_actions{gap:4px;flex-wrap:wrap}\n.recruiting-workspace .e2e_recruiting_actions button{padding:6px 8px;min-height:30px;font-size:10px;border-radius:7px}\n.recruiting-workspace .application-list-footer{align-items:center;flex-wrap:wrap;gap:10px;margin-top:10px}\n.recruiting-page-caption{color:#64748b;font-size:11px}\n.recruiting-workspace .application-list-footer .e2e_pagination_container{flex-wrap:wrap;gap:5px}\n.recruiting-workspace button:focus-visible,.recruiting-workspace .e2e_recruiting_table_wrapper:focus-visible{outline:2px solid #2563eb;outline-offset:3px}\n@keyframes recruiting-enter{from{opacity:0;transform:translateY(5px)}to{opacity:1;transform:translateY(0)}}\n@media(max-width:1100px){.recruiting-workspace .e2e_recruiting_right{width:100%}.recruiting-workspace .e2e_recruiting_right .recruiting-primary-button{margin-left:auto}}\n@media(max-width:680px){.recruiting-workspace{padding:12px}.recruiting-workspace .e2e_recruiting_top{align-items:stretch;gap:12px}.recruiting-title h2{font-size:20px}.recruiting-workspace .e2e_recruiting_right{display:grid;grid-template-columns:repeat(2,minmax(0,1fr))}.recruiting-workspace .e2e_recruiting_right button{width:100%;min-height:40px}.recruiting-workspace .e2e_recruiting_right .recruiting-primary-button{margin-left:0}.recruiting-workspace .application-list-controls{padding:10px}.recruiting-workspace .application-period-control,.recruiting-workspace .application-search-control,.recruiting-workspace .application-custom-dates{flex:auto;width:100%}.recruiting-workspace .application-list-footer{flex-direction:row}.recruiting-workspace .application-list-footer .e2e_pagination_container{width:100%;justify-content:center}.recruiting-workspace .recruiting-page-caption{margin-left:auto}}\n@media(prefers-reduced-motion:reduce){.recruiting-workspace{animation:none}.recruiting-workspace *{transition:none!important}}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
